// hero-pickup — interaction primitive.
//
// "Hero" extraction: the currently-focused product (selected via
// browse-1d) lifts out of its slot to a hold-position in front of the
// customer, where it can be examined / added to cart / returned.
//
// MIGRATION WINDOW (Phases 2d–6): the hero-pickup animation +
// reparenting + extract-target tweening all live in stage.js today
// (heroComic, heroExtract, _animateHeroExtract, etc.). This primitive
// publishes the hero-extract position from the slot-layout result onto
// composedEntry so stage.js's existing pickup flow finds it. Key
// trigger (typically E) is handled by the global dispatcher.
//
// AAA TARGET (Phase 6+): primitive owns the extraction animation +
// return-to-slot logic + per-fixture hero state; stage.js's global
// pickup code retires.
//
// Manifest contract (manifest.interactions[N] kind="hero-pickup"):
//   - target         "browsing-product" (the slot indexed by browseIndex)
//   - trigger        "E" today
//   - extractPath    optional catalogue node name overriding heroExtract
//                    (the slot-layout primitive already provides the
//                    default; this allows per-fixture override via a
//                    named-node in the catalogue GLB)

import { registerInteraction } from "./index.js";

function wireHeroPickup(ctx) {
	const { interactionDef, slotResult, composedEntry } = ctx;
	if (!composedEntry) return;

	// Hero-extract position comes from the slot-layout primitive's
	// extras (it knows lane geometry + extract-direction conventions).
	// Future: per-fixture override via a `manifest.interactions[N].extractPath`
	// pointing to a named node in the catalogue GLB — deferred until a
	// fixture genuinely needs it; for now slot-layout's default holds.
	composedEntry.heroPickup = {
		enabled: true,
		trigger: interactionDef?.trigger || "E",
	};
	if (slotResult?.extras?.heroExtract) {
		composedEntry.heroExtract = slotResult.extras.heroExtract.clone();
	}

	// No dispose work today — stage.js's global E-key dispatch handles
	// activation. Phase 6+ refactor returns a real dispose closure.
}

registerInteraction("hero-pickup", wireHeroPickup);

export { wireHeroPickup };
